import { l } from '@manychat/manyui'

export const INTENTS_LIMIT = 10
export const FAQ_FOLDER_ID_STORAGE_FIELD = 'bulk_faq_folder_id'
export const FOLDER_NAME = l.makeTranslate('AI automated FAQs')

export const EMPTY_BULK_FAQ_VALUES = [{ intentText: '', messageText: '' }]
